import ProjectEditDialogContent from '@/modals/ProjectEditDialogContent';
import { useDialog } from '@/providers/DialogProvider';
import { useCallback } from 'react';

export function useProjectEditDialog() {
  const { openDialog, dismissActiveDialog } = useDialog();

  return useCallback(
    (projectId: string) => {
      openDialog(
        <ProjectEditDialogContent projectId={projectId} onClose={dismissActiveDialog} />,
        'flex max-h-[calc(100dvh-2rem)] flex-col gap-0 overflow-hidden p-0 sm:max-w-[640px]',
        { dismissOnOutsideClick: false },
      );
    },
    [openDialog, dismissActiveDialog],
  );
}
